module.exports = __webpack_public_path__ + "static/img/role.1c2cd8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/lxx/role.png
// module id = KPKf
// module chunks = 7